import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import { theme } from '../../themes/theme'
import { BoldFormTitle, BoldMedBodyText } from '../styles/Text'
import { FlexColumn, FlexRow } from '../styles/Containers'

const IconWrapper = styled.div`
  display: flex;
  color: ${theme.colors.text.body};

  .MuiSvgIcon-root {
    width: 30px;
    transform: scale(1.2);
    transform-origin: center;
  }
`

const SettingName = styled(BoldFormTitle)`
  line-height: 22px;
  color: ${theme.colors.text.heading};
`

function SettingCard({ icon, label, description = '' }) {
  return (
    <FlexRow width="100%">
      <IconWrapper>{icon}</IconWrapper>
      <FlexColumn gap="10px">
        <SettingName>{label}</SettingName>
        <BoldMedBodyText>{description}</BoldMedBodyText>
      </FlexColumn>
    </FlexRow>
  )
}

SettingCard.propTypes = {
  icon: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  description: PropTypes.string
}

export default SettingCard
